module.exports = __webpack_public_path__ + "static/media/remove_prod_.e1c5d20f.svg";